import { BaseReducer } from '@hobs/utils/baseReducer';
import { GET, CLEAR_APPROVAL_SUMMARY } from '@hobs/constants/approvalSummary';

class ApprovalSummary extends BaseReducer {
  static defaultState = {
    units: []
  };

  constructor() {
    super(ApprovalSummary.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.addApprovalSummaryUnits,
      [CLEAR_APPROVAL_SUMMARY.SUCCESS]: this.clearApprovalSummary
    };
  }

  addApprovalSummaryUnits = (state, action) => {
    return Object.assign({}, state, { units: action.response });
  };

  clearApprovalSummary = (state) => {
    return Object.assign({}, state, { units: [] });
  };
}
export default new ApprovalSummary().reducer;
